import { splitFileName } from 'src/enviroment/lib/fileUtils'

/** Lower-case extension without the dot, or null — "README" and ".DS_Store" have none. */
export const fileExtension = (name: string): string | null => splitFileName(name).ext?.toLowerCase() ?? null
